module.exports = __webpack_public_path__ + "static/img/piece_2002.a8b90cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2002.png
// module id = 0u2X
// module chunks = 0